import React from "react";

const SocialIconsBar = () => {
  return (
    <ul className="social-icons">
      <li>
        <a href="#" target="_blank" title="">
          <i className="bx bxl-facebook-square"></i>
        </a>
      </li>
      <li>
        <a href="#" target="_blank" title="">
          <i className="bx bxl-twitter"></i>
        </a>
      </li>
      <li>
        <a href="#" target="_blank" title="">
          <i className="bx bxl-linkedin"></i>
        </a>
      </li>
      <li>
        <a href="#" target="_blank" title="">
          <i className="bx bxl-instagram"></i>
        </a>
      </li>
    </ul>
  );
};

export default SocialIconsBar;
